import { Model, modelRegistry } from './Model';
import Money from '../utilities/Money';
export class CashSale extends Model {
    static entity = 'cash_sales';
    id = null;
    user_id = null;
    date = null;
    paid_at_date = null;
    amount = '0.0000';
    created_at = null;
    updated_at = null;
    static fields() {
        return {
            id: this.attr(null),
            user_id: this.attr(null),
            date: this.attr(null),
            paid_at_date: this.attr(null),
            amount: this.attr('0.0000', value => this.round(value, 4).toFixed(4)),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    getAmount() {
        return Money.parse(this.amount);
    }
}
export default CashSale;
modelRegistry.register('CashSale', CashSale);
//# sourceMappingURL=CashSale.js.map